/**
 * Normalized Average True Range (NATR)
 *
 * ATR expressed as a percentage of the closing price, making it
 * comparable across different price levels.
 * NATR = (ATR / Close) * 100
 *
 * Category: Volatility | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeATR } from "./atr";

export const natrIndicator: IndicatorDefinition = {
  id: "natr",
  name: "Normalized ATR",
  shortName: "NATR",
  category: "volatility",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 14, min: 2, max: 100 },
  ],
  plots: [
    { key: "natr", label: "NATR", color: "#FF9800", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const atr = computeATR(candles, period);
    const natrData: { time: number; value: number }[] = [];

    for (let i = 0; i < candles.length; i++) {
      if (atr[i] !== undefined && candles[i].close > 0) {
        natrData.push({
          time: candles[i].time,
          value: (atr[i] / candles[i].close) * 100,
        });
      }
    }

    return [{ key: "natr", data: natrData }];
  },
};
